import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { Controller, Control } from "react-hook-form";
import { FLAG_OPTIONS } from "@/components/FlagOptions";

interface FlagForUpdatesFieldProps {
  control: Control<any>;
}

export const FlagForUpdatesField: React.FC<FlagForUpdatesFieldProps> = ({
  control,
}) => {
  return (
    <Controller
      name="flag_for_updates"
      control={control}
      render={({ field }) => (
        <>
          <FormControl fullWidth margin="normal">
            <InputLabel id="flag-for-updates-label">
              Flag for Updates
            </InputLabel>
            <Select
              labelId="flag-for-updates-label"
              label="Flag for Updates"
              value={
                field.value && field.value.startsWith("Other:")
                  ? "Other"
                  : field.value || ""
              }
              onChange={(e) => {
                if (e.target.value === "Other") {
                  const currentText =
                    field.value && field.value.startsWith("Other:")
                      ? field.value.substring(6)
                      : "";
                  field.onChange(`Other:${currentText}`);
                } else {
                  field.onChange(e.target.value);
                }
              }}
            >
              <MenuItem value="">None</MenuItem>
              {FLAG_OPTIONS.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>

          {field.value && field.value.startsWith("Other:") && (
            <TextField
              margin="normal"
              fullWidth
              multiline
              rows={2}
              label="Please specify"
              value={field.value.substring(6)}
              onChange={(e) => field.onChange(`Other:${e.target.value}`)}
            />
          )}
        </>
      )}
    />
  );
};
